<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <div class="inputSearch">
        <v-row>
          <v-col cols="12" md="4" lg="4">
            <v-text-field
              v-model="title"
              label="Kỳ đóng"
              return-object
              clearable
              flat
              outlined
              dense
              hide-details
              @keyup.enter="onFilterChange"
            />
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-select
              v-model="selectedStatus"
              :items="periodStatusList"
              clear-icon="mdi-close"
              item-text="name"
              item-value="value"
              label="Trạng thái"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
      </div>
      <div class="buttonSearch">
        <div class="d-flex flex-column justify-start">
          <v-btn class="search-button" @click="onFilterChange" outlined>
            Tìm kiếm
          </v-btn>
        </div>
      </div>
    </v-row>
  </v-form>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    selectedStatus: '',
    title: '',
    periodStatusList: [
      { name: 'Chưa tổng kết', value: 'created' },
      { name: 'Đang tổng kết', value: 'running' },
      { name: 'Đã tổng kết', value: 'finished' }
    ],
  }),
  methods: {
    ...mapActions('salaryPeriod', ['searchPeriod']),
    async onFilterChange() {
      await this.searchPeriod({
        title_contains: this.title,
        status_contains: this.selectedStatus
      })
    }
  }
}
</script>
<style lang="scss" scoped>
div.buttonSearch {
  width: 110px;
}
div.inputSearch {
  width: calc(100% - 120px - 12px);
}
@media screen and (max-width: 960px) {
  div.buttonSearch {
    width: 110px;
    padding-top: 24px;
    margin-left: 0px !important;
  }
  div.inputSearch {
    width: 100%;
    padding-right: 24px;
  }
}
</style>
